import JSPDF from 'jspdf'
import 'jspdf-autotable'
import XLSX from 'xlsx/dist/xlsx.full.min.js'
import moment from 'moment'

const toPdf = function (data, nombreGrafico, cols, tipo) {
  nombreGrafico = nombreGrafico.replace(' ', '_')
  if (tipo === 'datatable') {
    if (data) {
      const doc = new JSPDF()
	        const columns = Object.keys(data[0]).map(key => {
	            return { header: key.replace('_name_', 'nombre').toUpperCase(), dataKey: key }
	        })
	        doc.text(nombreGrafico, doc.internal.pageSize.getWidth() / 2, 10, { align: 'center' })
	        doc.autoTable({ columns, body: data })
	        doc.save(`${nombreGrafico}.pdf`)
    }
  } else {
    if (data.data) {
	        const doc = new JSPDF()
	        const columns = Object.keys(data.data[0]).map(key => {
	            return { header: key.replace('_name_', 'nombre').toUpperCase(), dataKey: key }
	        })
	        doc.text(nombreGrafico, doc.internal.pageSize.getWidth() / 2, 10, { align: 'center' })
	        doc.autoTable({ columns, body: data.data })
	        doc.save(`${nombreGrafico}.pdf`)
	    }
  }
}

const toExcel = function (data, nombreGrafico, cols, tipo) {
  if (tipo === 'datatable') {
    if (data) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data)
      var titulo = ''
      if (nombreGrafico > 30) {
        titulo = nombreGrafico.slice(0, 29).replace(' ', '_')
      } else {
        titulo = nombreGrafico.replace(' ', '_')
      }
      var tituloCorto = nombreGrafico.slice(0, 30).replace(/[^\w\s]/gi, '')
      XLSX.utils.book_append_sheet(doc, tableEx, tituloCorto)
      XLSX.writeFile(doc, `${tituloCorto}.xlsx`)
    }
  } else {
    if (data.data) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data.data)
      var titulo = ''
      if (data.titulo > 30) {
        titulo = data.titulo.slice(0, 29).replace(' ', '_')
      } else {
        titulo = data.titulo.replace(' ', '_')
      }
      var tituloCorto = data.titulo.slice(0, 30).replace(/[^\w\s]/gi, '')
      XLSX.utils.book_append_sheet(doc, tableEx, tituloCorto)
      XLSX.writeFile(doc, `${tituloCorto}.xlsx`)
    }
  }
}

const toExcelTwo = function (data, nombreGrafico, cols, tipo) {
  if (tipo === 'datatable') {
    if (data) {
      var doc = XLSX.utils.book_new()

      var tableEx = XLSX.utils.json_to_sheet(data)
      var nombre = ''
      if (data.nombre > 30) {
        nombre = data.nombre.slice(0, 29).replace(' ', '_')
      } else {
        nombre = data.nombre.replace(' ', '_')
      }
      var tituloCortoDos = data.nombre.slice(0, 30).replace(/[^\w\s]/gi, '')
      XLSX.utils.book_append_sheet(doc, tableEx, tituloCortoDos)
      XLSX.writeFile(doc, `${tituloCortoDos}.xlsx`)
    }
  } else {
    if (data.data) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data.data)
      var nombre = ''
      if (data.nombre > 30) {
        nombre = data.nombre.slice(0, 29)
      } else {
        nombre = data.nombre.replace(' ', '_')
      }
      var tituloCortoDos = data.nombre.slice(0, 30).replace(/[^\w\s]/gi, '')
      XLSX.utils.book_append_sheet(doc, tableEx, tituloCortoDos)
      XLSX.writeFile(doc, `${tituloCortoDos}.xlsx`)
    }
  }
}

const toExcelThree = function (data, nombreGrafico, cols, tipo) {
  if (tipo === 'datatable') {
    if (data.length) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data)
      var title = ''
      if (nombreGrafico > 30) {
        title = nombreGrafico.slice(0, 29).replace(/[^\w\s]/gi, '')
      } else {
        title = nombreGrafico.replace(/[^\w\s]/gi, '')
      }

      var fecha = new Date()
      var dd = fecha.getDate()
      var mm = fecha.getMonth() + 1
      var yyyy = fecha.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }

      var fecha = dd + '-' + mm + '-' + yyyy
      XLSX.utils.book_append_sheet(doc, tableEx, title)
      XLSX.writeFile(doc, `${nombreGrafico + '_' + fecha}.xlsx`)
    }
  } else {
    if (data.data.length) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data.data)
      var title = ''
      if (data.title.length > 30) {
        title = data.title.slice(0, 29)
      } else {
        title = data.title
      }

      var fecha = new Date()
      var dd = fecha.getDate()
      var mm = fecha.getMonth() + 1
      var yyyy = fecha.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }

      var fecha = dd + '-' + mm + '-' + yyyy

      XLSX.utils.book_append_sheet(doc, tableEx, title)
      XLSX.writeFile(doc, `${data.title.replace(/[^\w\s]/gi, '') + '_' + fecha}.xlsx`)
    }
  }
}

const toExcelAP = function (data, tipo, date) {
  if (data.length) {
    var doc = XLSX.utils.book_new()
    var tableEx = XLSX.utils.json_to_sheet(data)
    var title = ''
    var fechaDesde = moment(date[0]).format('DD-MM-YYYY')
    var fechaHasta = moment(date[1]).format('DD-MM-YYYY')
    var fecha = fechaDesde + '_a_' + fechaHasta

    if (tipo === 'asignadas') {
      title = 'actividades_asignadas'
    } else if (tipo === 'finalizadas') {
      title = 'actividades_finalizadas'
    }

    XLSX.utils.book_append_sheet(doc, tableEx, title)
    XLSX.writeFile(doc, `${title + '_' + fecha}.xlsx`)
  } else {
    if (data.data) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(data)
      var title = ''
      var fechaDesde = moment(date[0]).format('DD-MM-YYYY')
      var fechaHasta = moment(date[1]).format('DD-MM-YYYY')
      var fecha = fechaDesde + '_a_' + fechaHasta

      if (tipo === 'asignadas') {
        title = 'actividades_asignadas'
      } else if (tipo === 'finalizadas') {
        title = 'actividades_finalizadas'
      }

      XLSX.utils.book_append_sheet(doc, tableEx, title)
      XLSX.writeFile(doc, `${title.replace(/[^\w\s]/gi, '') + '_' + fecha}.xlsx`)
    }
  }
}

const toExcelAPA = function (data, data2, date) {
  const newData = []

  for (let x = 0; x < data.length; x++) {
    newData.push(data[x])
  }

  for (let y = 0; y < data2.length; y++) {
    newData.push(data2[y])
  }

  if (newData.length) {
    var doc = XLSX.utils.book_new()
    var tableEx = XLSX.utils.json_to_sheet(newData)
    var title = 'Mis Actividades'
    var fecha = moment(date).format('DD-MM-YYYY')

    XLSX.utils.book_append_sheet(doc, tableEx, title)
    XLSX.writeFile(doc, `${title + '_' + fecha}.xlsx`)
  } else {
    if (newData.data) {
      var doc = XLSX.utils.book_new()
      var tableEx = XLSX.utils.json_to_sheet(newData)
      var title = 'Mis Actividades'
      var fecha = moment(date).format('DD-MM-YYYY')

      XLSX.utils.book_append_sheet(doc, tableEx, title)
      XLSX.writeFile(doc, `${title.replace(/[^\w\s]/gi, '') + '_' + fecha}.xlsx`)
    }
  }
}

export { toPdf, toExcel, toExcelTwo, toExcelThree, toExcelAP, toExcelAPA }
